const _ = require('lodash');
module.exports = function (catalogService, breakpointsService) {
    return {
        restrict: 'E',
        scope: {
            isFromCheckout: '=?'
        },
        template: require('./explore-category-template.html'),
        link(scope) {
            scope.categories = (catalogService.topLevelCategories).slice(0, 4);
            scope.isMob = breakpointsService.isSmallFormat();
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/explore-categories/explore-category.js
 **/